import Breadcrumb from 'react-bootstrap/Breadcrumb'
import './breadcrumb.scss'
import { useHistory } from 'react-router-dom'

function BreadcrumbSample({ goToHome, goToAccDetail, activePage }) {
  const history = useHistory()
  // const navigate = (path) => history.push(path)
  if (!goToHome) {
    return <></>
  }
  return (
    <Breadcrumb>
      <Breadcrumb.Item onClick={goToHome}>Home</Breadcrumb.Item>
      {goToAccDetail && (
        <Breadcrumb.Item onClick={goToAccDetail}>
          Account Details
        </Breadcrumb.Item>
      )}
      {activePage && <Breadcrumb.Item active>{activePage}</Breadcrumb.Item>}
    </Breadcrumb>
  )
}

export default BreadcrumbSample
